import React from 'react';
import { Button } from '../ui/button';
import { Card, CardContent } from '../ui/card';

const SEStockCard = ({ req, processing, onApprove, onReject }) => {
  const payload = req.se_payload || {};
  const totalQty = (payload.items || []).reduce((s, i) => s + (i.variants || []).reduce((vs, v) => vs + (v.qty || 0), 0), 0);
  return (
    <Card className="border-l-4 transition-shadow hover:shadow-md" style={{ borderLeftColor: '#f59e0b' }} data-testid={`se-stock-card-${req.id}`}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <div className="flex items-center gap-2 mb-1">
              <span className="px-2 py-0.5 bg-amber-100 text-amber-800 text-xs font-bold rounded-full border border-amber-300">STOCK OVERRIDE</span>
              <span className="text-xs text-gray-500">{new Date(req.requested_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
            </div>
            <p className="text-sm text-gray-700"><span className="font-medium">Requested by:</span> {req.requested_by_name}</p>
            <p className="text-sm text-gray-700"><span className="font-medium">Customer:</span> {req.customer_name || 'N/A'}</p>
            <p className="text-sm text-gray-700"><span className="font-medium">Total Qty:</span> {totalQty} pcs</p>
            <div className="mt-2">
              <p className="text-xs font-semibold text-red-700 mb-1">Insufficient Items:</p>
              <div className="text-xs bg-red-50 border border-red-200 rounded p-2">
                {(req.insufficient_items || []).map((it, idx) => (
                  <div key={idx} className="flex gap-4">
                    <span className="font-semibold">{it.design_code}</span>
                    <span>{it.size}/{it.color}</span>
                    <span>Available: <strong>{it.available}</strong></span>
                    <span>Requested: <strong>{it.requested}</strong></span>
                    <span className="text-red-600 font-bold">Short: {it.requested - it.available}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="flex flex-col gap-2">
            <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white" disabled={processing === req.id}
              onClick={() => onApprove(req)} data-testid={`approve-se-stock-${req.id}`}>
              Approve
            </Button>
            <Button size="sm" variant="outline" className="border-red-300 text-red-600 hover:bg-red-50" disabled={processing === req.id}
              onClick={() => onReject(req)} data-testid={`reject-se-stock-${req.id}`}>
              Reject
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SEStockCard;
